import {EntityTypeLabelPair, IFieldMeta} from '../../interfaces/imetadata';
import {SignatureField} from '../../interfaces/signature';
import {DateFormatOptions} from '../../utils/fieldconfig';

export enum AdcMigrationStatus {
  MIGRATABLE,
  NOT_RECOGNISED,
  NOT_SUPPORTED,
  NO_SUCH_FIELD,
  COMPLETED,
}

export type AdcMigrationFieldOptions = {
  date: DateFormatOptions;
  default: string;
};

export type AdcMigrationFieldMeta = {
  entity?: EntityTypeLabelPair;
  meta?: IFieldMeta;
  options?: AdcMigrationFieldOptions;
};

export type AdcMigrationProcessedFieldInfo = {
  description: string;
  status: AdcMigrationStatus;
  meta?: AdcMigrationFieldMeta | SignatureField;
};

export type AdcMigrationFieldInfo = {
  index: number;
  expression: string;
  description: string;
  status: AdcMigrationStatus;
  meta: AdcMigrationFieldMeta | SignatureField;
};
